import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class NAOTypeService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/NAOTypes`);
    }
}